import { render, staticRenderFns } from "./listTaskDetial.vue?vue&type=template&id=5ef2013d&scoped=true"
import script from "./listTaskDetial.vue?vue&type=script&lang=js"
export * from "./listTaskDetial.vue?vue&type=script&lang=js"
import style0 from "./listTaskDetial.vue?vue&type=style&index=0&id=5ef2013d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2013d",
  null
  
)

export default component.exports